
import apiClient from "../core/apiClient";
import { User } from "../interfaces/DTO/user";

import { BaseService } from "./BaseService";

const API_URL = "/users";

class UserService extends BaseService<User> {
  constructor() {
    super(API_URL);
  }

 


}

export const userService = new UserService();
